import { OnlyCharacterDirective } from './directive/only-character.directive';
import { IntegerDirective } from './directive/integer.directive';
import { NumberCharacterDirective } from './directive/number-character.directive';
import { AccountNumberDirective } from './directive/account-number.directive';
import { PanValidationDirective } from './directive/pan-validation.directive';
import { PinCodeDirective } from './directive/pin-code.directive';
import { AllowNumberOnlyDirective } from './directive/allow-number-only.directive';
import { AllowNumberOnlyPosNegDirective } from './directive/allow-number-only-pos-neg.directive';
import { PhoneValidationDirective } from './directive/phone-validation.directive';
import { EmailValidationDirective } from './directive/email-validation.directive';
import { UpperCaseDirective } from './directive/upper-case.directive';
import { SearchPipe } from './pipes/search.pipe';
import { DataPipePipe } from './pipes/data-pipe.pipe';
import { DropdownSearchPipe } from './pipes/dropdown-search.pipe';
import { NgModule } from '@angular/core';
import { TimeAgoPipe } from 'time-ago-pipe';
import { KeySearchPipe } from './pipes/key-search.pipe';
import { FocusDirectiveDirective } from './directive/focus-directive.directive';
import { InvoiceNoDirective } from './directive/invoice-no.directive';
import { SpaceAllowedDirective } from './directive/space-allowed.directive';
import { DebounceInputDirective } from './directive/debounce-input.directive';
import { SetGetSearchPipe } from './pipes/set-get-search.pipe';
import { NoBracketsDirective } from './directive/no-brackets.directive';
import { CurrencyFormatterInrPipe } from './pipes/currency-formatter-inr.pipe';
import { ProductSearchPipe } from './pipes/product-search.pipe';
import { EmployeeNoDirective } from './directive/employee-no.directive';
// import { PrSearchPipe } from './pipes/pr-search.pipe';

@NgModule({
  imports: [],
  exports: [
    TimeAgoPipe,
    DropdownSearchPipe,
    DataPipePipe,
    SearchPipe,
    UpperCaseDirective,
    EmailValidationDirective,
    PhoneValidationDirective,
    AllowNumberOnlyDirective,
    AllowNumberOnlyPosNegDirective,
    PinCodeDirective,
    PanValidationDirective,
    OnlyCharacterDirective,
    AccountNumberDirective,
    NumberCharacterDirective,
    IntegerDirective,
    KeySearchPipe,
    InvoiceNoDirective,
    SpaceAllowedDirective,
    DebounceInputDirective,
    SetGetSearchPipe,
    NoBracketsDirective,
    ProductSearchPipe,
    // PrSearchPipe
    CurrencyFormatterInrPipe,
    EmployeeNoDirective
  ],
  declarations: [
    TimeAgoPipe,
    DropdownSearchPipe,
    DataPipePipe,
    SearchPipe,
    UpperCaseDirective,
    EmailValidationDirective,
    PhoneValidationDirective,
    AllowNumberOnlyDirective,
    AllowNumberOnlyPosNegDirective,
    PinCodeDirective,
    PanValidationDirective,
    OnlyCharacterDirective,
    AccountNumberDirective,
    NumberCharacterDirective,
    IntegerDirective,
    KeySearchPipe,
    FocusDirectiveDirective,
    InvoiceNoDirective,
    SpaceAllowedDirective,
    DebounceInputDirective,
    SetGetSearchPipe,
    NoBracketsDirective,
    ProductSearchPipe,
    CurrencyFormatterInrPipe,
    EmployeeNoDirective
    // PrSearchPipe
  ],
  providers: []
})
export class SharedModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1860559092/src/src/app/shared/shared.module.ts